import { ProductSlimResponseDTO } from "@shared/DTO";

/**
 * Creates the local, editorially ordered product set for one listing instance.
 * It never mutates the source array, which can be shared by ProductsApi cache consumers.
 */
export const composeProducts = (
  sourceProducts: ReadonlyArray<ProductSlimResponseDTO>,
  productIds: readonly string[],
): ProductSlimResponseDTO[] => {
  if (!productIds.length) return [...sourceProducts];

  const productsById = new Map(
    sourceProducts.map((product) => [String(product._id), product]),
  );

  return productIds
    .map((productId) => productsById.get(productId))
    .filter((product): product is ProductSlimResponseDTO => !!product);
};
